var map = {
	"./adaptiveai.svg": "lCWc",
	"./explainableai.svg": "NUsO",
	"./intro.svg": "6sXR",
	"./onesolution.svg": "ysSE",
	"./pnp.svg": "4aMg",
	"./selfoptimisation.svg": "iet8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "MCGp";


//////////////////
// WEBPACK FOOTER
// ./src/img/mlstudio ^\.\/.*\.svg$
// module id = MCGp
// module chunks = 39 44